<template>
  <van-popup v-model="showPicker" round position="bottom">
    <van-area
      :area-list="currentAreaList"
      :value="code"
      :columns-num="keys.length || columnsNum"
      :columns-placeholder="['请选择', '请选择', '请选择']"
      :swipe-duration="300"
      @confirm="onConfirm"
      @change="onChange"
      @cancel="showPicker = false"
      title="选择区域"
    />
  </van-popup>
</template>
<script>
// import { areaList } from "@vant/area-data";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    keys: {
      type: Array,
      default: () => []
    },
    code: {
      type: String,
      default: ""
    },
    columnsNum: {
      type: Number,
      default: 3
    },
    onlyArea: {
      type: String,
      default: "440000"
    },
    areaList: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentAreaList: { province_list: {}, city_list: {}, county_list: {} }
    };
  },
  computed: {
    showPicker: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  watch: {
    showPicker(v) {
      this.handleAreaList();
    },
    areaList: {
      handler(v) {
        this.handleAreaList();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleAreaList() {
      if (this.onlyArea) {
        const area = this.onlyArea.slice(0, 2);
        const onlyAreaList = {
          city_list: this.filterAreaByKey(area, this.areaList.city_list),
          county_list: this.filterAreaByKey(area, this.areaList.county_list),
          province_list: {
            [this.onlyArea]: this.areaList.province_list[this.onlyArea]
          }
        };
        this.currentAreaList = onlyAreaList;
      } else {
        this.currentAreaList = this.areaList;
      }
    },
    filterAreaByKey(str, are) {
      let area = {};
      for (let key in are) {
        if (key.slice(0, 2) == str) {
          area[key] = are[key];
        }
      }
      return area;
    },
    onChange(v) {
      console.log(v);
    },
    onConfirm(v) {
      let arr = (v || []).filter(Boolean);
      const codes = arr.map((e) => e?.code);
      const names = arr.map((e) => e?.name);
      if (!codes[codes.length - 1]) {
        this.$errMsg("至少选择到市区");
        return;
      }
      this.showPicker = false;
      this.$emit("confirm", codes, names);
    }
  }
};
</script>
